import { render } from "./GiftsView.vue?vue&type=template&id=67358d58"
import script from "./GiftsView.vue?vue&type=script&lang=js"
export * from "./GiftsView.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__